import React, { Suspense, lazy } from "react";
import { Spin } from "antd";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import axios from "axios";
import store from "./redux/store";
import { fetchCeToken } from "./redux/actions";
import { installCeTokenRefresh } from "./utils/ceToken";
import "./index.css";
const App = lazy(() => import("./App"));

installCeTokenRefresh(axios, () => store.dispatch(fetchCeToken()));

const domNode = document.getElementById("root");
const root = createRoot(domNode);

root.render(
    <Provider store={store}>
      <Suspense fallback={<Spin size="large" />}>
        <App />
      </Suspense>
    </Provider>
);
